import React from 'react';
import { Button, Col, Form, Input, Radio, Row, Select } from 'antd';
import { useDispatch } from 'react-redux';
import { doCreateIssue } from '../../../modules/issues/stores/thunk';
import { useSelector } from 'react-redux';
import { ROLES } from '../../../constants';

const ReportIssueForm = ({ issue, userId, onCancel, onSuccess }) => {
  const { orderId, carrierName, companyName } = issue;
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [currentLength, setCurrentLength] = React.useState(0);
  const userRole = useSelector((state) => state.auth.user.role);

  const handleMessageChange = (e) => {
    setCurrentLength(e.target.value.length);
  };

  const onFinishForm = async (values) => {
    const { payload } = await dispatch(
      doCreateIssue({
        orderId,
        creatorUserId: userId,
        ...values,
      }),
    );
    form.resetFields();
    if (onSuccess) {
      onSuccess(payload);
      return;
    }
    if (onCancel) {
      onCancel();
    }
  };

  return (
    <Form form={form} onFinish={onFinishForm} requiredMark={false}>
      <Row gutter={24}>
        {userRole === ROLES.ADMIN && (
          <>
            {/* <Col span={24}>
              <Form.Item
                label="Priority"
                name="priority"
                labelCol={{ span: 4 }}
                wrapperCol={{ span: 20 }}
                rules={[{ required: true, message: 'Select a priority' }]}
              >
                <Radio.Group>
                  <Radio.Button
                    value="LOW"
                    style={{
                      width: '100%',
                      textAlign: 'center',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    🟢 Low
                  </Radio.Button>
                  <Radio.Button
                    value="MEDIUM"
                    style={{
                      width: '100%',
                      textAlign: 'center',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    🟧 Medium
                  </Radio.Button>
                  <Radio.Button
                    value="HIGH"
                    style={{
                      width: '100%',
                      textAlign: 'center',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    🚨 High
                  </Radio.Button>
                </Radio.Group>
              </Form.Item>
            </Col> */}
            <Col span={24}>
              <Form.Item
                label="Share with"
                name="sharedWith"
                labelCol={{ span: 4 }}
                wrapperCol={{ span: 20 }}
                rules={[{ required: true, message: 'Select who you share the issue with' }]}
              >
                <Radio.Group>
                  <Radio.Button
                    value="CARRIER"
                    style={{
                      width: '100%',
                      textAlign: 'center',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    Carrier - {carrierName}
                  </Radio.Button>
                  <Radio.Button
                    value="COMPANY"
                    style={{
                      width: '100%',
                      textAlign: 'center',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    Company - {companyName}
                  </Radio.Button>
                </Radio.Group>
              </Form.Item>
            </Col>
          </>
        )}
      </Row>
      <Row gutter={24}>
        <Col span={24}>
          <Form.Item
            label="Reason"
            name="reason"
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 20 }}
            rules={[{ required: true, message: '' }]}
          >
            <Select placeholder="Select a reason">
              <Select.Option value="delayed">Delayed</Select.Option>
              <Select.Option value="completed-not-received">Completed, not received</Select.Option>
              <Select.Option value="damaged">Damaged</Select.Option>
              <Select.Option value="lost">Lost</Select.Option>
              <Select.Option value="incorrect-return-to-sender">Incorrect Return to sender</Select.Option>
              <Select.Option value="incorrect-delivery">Incorrect Delivery</Select.Option>
              <Select.Option value="other">Other</Select.Option>
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={24}>
          <Form.Item
            label="Message"
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 20 }}
            name="message"
            rules={[{ required: true, message: '' }]}
          >
            <Input.TextArea
              placeholder="Please describe the issue"
              rows={6}
              maxLength={500}
              onChange={(e) => {
                handleMessageChange(e); // For counting characters
                form.setFieldValue('message', e.target.value); // Sync with form
              }}
            />
            <div style={{ marginTop: '8px', textAlign: 'right' }}>
              <span style={{ fontSize: 'smaller' }}>{currentLength}/500</span>
            </div>
          </Form.Item>
        </Col>
      </Row>
      <div className="FormFooter">
        <div className="actions">
          <Button className="ButtonCancel" onClick={onCancel}>
            Cancel
          </Button>
          <Button type="primary" htmlType="submit" block size="large">
            Submit Issue
          </Button>
        </div>
      </div>
    </Form>
  );
};

export default ReportIssueForm;
